export const messages = {
  en: {
    contractCreateFee: {
      search: {
        title: 'Search Conditions',
        contractCode: 'Contract Code',
        contractNameLike: 'Contract Name',
        contractType: 'Contract Type'
      },
      list: {
        title: 'Contract Information',
        batchCreate: 'Batch Create'
      },
      table: {
        contractCode: 'Contract Code',
        parentContractCode: 'Parent Contract Code',
        contractName: 'Contract Name',
        contractType: 'Contract Type',
        partyB: 'Party B',
        amount: 'Amount',
        startTime: 'Start Time',
        endTime: 'End Time',
        operation: 'Operation',
        payFee: 'Pay Fee',
        viewDetail: 'Detail',
        viewFee: 'View Fee'
      },
      fetchError: 'Failed to fetch contract data'
    },
    contractCreateFeeAdd: {
      title: 'Create Fee',
      feeTypeCd: 'Fee Type',
      configId: 'Fee Item',
      amount: 'Amount',
      contractState: 'Contract State',
      startTime: 'Start Time',
      endTime: 'End Time',
      selectFeeType: 'Please select fee type',
      selectFeeConfig: 'Please select fee item',
      inputAmount: 'Please input amount',
      selectStartTime: 'Select start time',
      selectEndTime: 'Select end time',
      state2001: 'Pending Review',
      state2003: 'Under Review',
      state2005: 'Review Completed',
      feeTypeRequired: 'Fee type is required',
      configRequired: 'Fee item is required',
      amountRequired: 'Amount is required',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      timeError: 'Start time must be earlier than end time',
      success: 'Successfully created fees. Total: {total}, Success: {success}, Failed: {error}',
      note: 'Note: Batch created fees will be displayed in the contract fee view'
    }
  },
  zh: {
    contractCreateFee: {
      search: {
        title: '查询条件',
        contractCode: '合同编号',
        contractNameLike: '合同名称',
        contractType: '合同类型'
      },
      list: {
        title: '合同信息',
        batchCreate: '批量创建'
      },
      table: {
        contractCode: '合同编号',
        parentContractCode: '父合同编号',
        contractName: '合同名称',
        contractType: '合同类型',
        partyB: '乙方',
        amount: '合同金额(元)',
        startTime: '开始时间',
        endTime: '结束时间',
        operation: '操作',
        payFee: '欠费缴费',
        viewDetail: '详情',
        viewFee: '查看费用'
      },
      fetchError: '获取合同数据失败'
    },
    contractCreateFeeAdd: {
      title: '创建费用',
      feeTypeCd: '费用类型',
      configId: '收费项目',
      amount: '收费金额(元)',
      contractState: '合同状态',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      selectFeeType: '请选择费用类型',
      selectFeeConfig: '请选择收费项目',
      inputAmount: '请填写收费金额(元)',
      selectStartTime: '请填写计费起始时间',
      selectEndTime: '请填写计费结束时间',
      state2001: '待审核',
      state2003: '审核中',
      state2005: '审核完成',
      feeTypeRequired: '费用类型不能为空',
      configRequired: '费用项目不能为空',
      amountRequired: '收费金额(元)不能为空',
      startTimeRequired: '计费起始时间不能为空',
      endTimeRequired: '计费结束时间不能为空',
      timeError: '计费起始时间必须小于计费终止时间',
      success: '创建收费成功，总共[{total}]合同，成功[{success}],失败[{error}]',
      note: '注：批量创建的费用在合同收费的查看费用中显示'
    }
  }
}